package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String
import kotlin.collections.Map

public object ResStrings {
  private val baseLocale: StringsEn = StringsEn

  private val locales: Map<String, Strings> = mapOf("de" to StringsDe, "tr" to StringsTr, "en" to
      StringsEn)

  public val home: String
    get() = locales[getCurrentLanguageCode()]?.home ?: baseLocale.home

  public val about: String
    get() = locales[getCurrentLanguageCode()]?.about ?: baseLocale.about

  public val contact: String
    get() = locales[getCurrentLanguageCode()]?.contact ?: baseLocale.contact

  public val book_stands: String
    get() = locales[getCurrentLanguageCode()]?.book_stands ?: baseLocale.book_stands

  public val search: String
    get() = locales[getCurrentLanguageCode()]?.search ?: baseLocale.search

  public val create_library: String
    get() = locales[getCurrentLanguageCode()]?.create_library ?: baseLocale.create_library

  public val footer_author: String
    get() = locales[getCurrentLanguageCode()]?.footer_author ?: baseLocale.footer_author

  public val section1_title: String
    get() = locales[getCurrentLanguageCode()]?.section1_title ?: baseLocale.section1_title

  public val section1_button: String
    get() = locales[getCurrentLanguageCode()]?.section1_button ?: baseLocale.section1_button

  public val section1_desc: String
    get() = locales[getCurrentLanguageCode()]?.section1_desc ?: baseLocale.section1_desc

  public val section2_title: String
    get() = locales[getCurrentLanguageCode()]?.section2_title ?: baseLocale.section2_title

  public val section2_button: String
    get() = locales[getCurrentLanguageCode()]?.section2_button ?: baseLocale.section2_button

  public val section2_desc: String
    get() = locales[getCurrentLanguageCode()]?.section2_desc ?: baseLocale.section2_desc

  public val section3_title: String
    get() = locales[getCurrentLanguageCode()]?.section3_title ?: baseLocale.section3_title

  public val section3_button: String
    get() = locales[getCurrentLanguageCode()]?.section3_button ?: baseLocale.section3_button

  public val section3_desc: String
    get() = locales[getCurrentLanguageCode()]?.section3_desc ?: baseLocale.section3_desc

  public val shipping_title: String
    get() = locales[getCurrentLanguageCode()]?.shipping_title ?: baseLocale.shipping_title

  public val shipping_desc1: String
    get() = locales[getCurrentLanguageCode()]?.shipping_desc1 ?: baseLocale.shipping_desc1

  public val shipping_description: String
    get() = locales[getCurrentLanguageCode()]?.shipping_description ?:
        baseLocale.shipping_description

  public val shipping_description2: String
    get() = locales[getCurrentLanguageCode()]?.shipping_description2 ?:
        baseLocale.shipping_description2

  public val contact_title: String
    get() = locales[getCurrentLanguageCode()]?.contact_title ?: baseLocale.contact_title

  public val contact_email_name: String
    get() = locales[getCurrentLanguageCode()]?.contact_email_name ?: baseLocale.contact_email_name

  public val contact_email_subject: String
    get() = locales[getCurrentLanguageCode()]?.contact_email_subject ?:
        baseLocale.contact_email_subject

  public val contact_email_message: String
    get() = locales[getCurrentLanguageCode()]?.contact_email_message ?:
        baseLocale.contact_email_message

  public val contact_email_send_message: String
    get() = locales[getCurrentLanguageCode()]?.contact_email_send_message ?:
        baseLocale.contact_email_send_message

  public val library_header_title: String
    get() = locales[getCurrentLanguageCode()]?.library_header_title ?:
        baseLocale.library_header_title

  public val library_header_title2: String
    get() = locales[getCurrentLanguageCode()]?.library_header_title2 ?:
        baseLocale.library_header_title2

  public val library_header_desc: String
    get() = locales[getCurrentLanguageCode()]?.library_header_desc ?: baseLocale.library_header_desc

  public val library_header_desc2: String
    get() = locales[getCurrentLanguageCode()]?.library_header_desc2 ?:
        baseLocale.library_header_desc2

  public val copy_your_id: String
    get() = locales[getCurrentLanguageCode()]?.copy_your_id ?: baseLocale.copy_your_id

  public val download_book_list: String
    get() = locales[getCurrentLanguageCode()]?.download_book_list ?: baseLocale.download_book_list

  public val ok: String
    get() = locales[getCurrentLanguageCode()]?.ok ?: baseLocale.ok

  public val remove: String
    get() = locales[getCurrentLanguageCode()]?.remove ?: baseLocale.remove

  public val search_author: String
    get() = locales[getCurrentLanguageCode()]?.search_author ?: baseLocale.search_author

  public val result_found: String
    get() = locales[getCurrentLanguageCode()]?.result_found ?: baseLocale.result_found

  public val loading: String
    get() = locales[getCurrentLanguageCode()]?.loading ?: baseLocale.loading

  public val not_load: String
    get() = locales[getCurrentLanguageCode()]?.not_load ?: baseLocale.not_load
}
